import { Component, OnInit, ViewChild } from '@angular/core';
import { Persona } from 'src/app/models/Persona';
import { ExternosService } from 'src/app/services/externos/externos.service';
import { MatDialog, MatTableDataSource, MatPaginator, MatSort, MatDialogConfig } from '@angular/material';
import { openModalMensaje, DscTituloPaginator, NumIdTipDocPersJur, openModalMensajePrg, strDscMsjPrgEliminar, iconAgregar, iconEliminar, getBooleanFlag, ConvertirFlag, isEmpty, NumIdTipoDocRUC, DscMensajeSpinner, strMatTablePaginator } from 'src/app/general/variables';
import { MaestrasService } from 'src/app/services/maestra/maestras.service';
import { Departamento } from 'src/app/models/Departamento';
import { Provincia } from 'src/app/models/Provincia';
import { Distrito } from 'src/app/models/Distrito';
import { PersonaXRepLeg } from 'src/app/models/PersonaXRepLeg';
import { EmpresaSunat } from 'src/app/models/EmpresaSunat';
import { Denunciante } from 'src/app/models/Denunciante';
import { NgxSpinnerService } from 'ngx-spinner';
import { cloneDeep, forEach } from 'lodash';
import { ModalRepLegalComponent } from '../modal-rep-legal/modal-rep-legal.component';
import { DenuncianteXRepLegal } from 'src/app/models/DenuncianteXRepLegal';
import { PersonaService } from 'src/app/services/persona.service';

@Component({
  selector: 'app-datos-empresa-denunc',
  templateUrl: './datos-empresa-denunc.component.html',
  styleUrls: ['./datos-empresa-denunc.component.css']
})
export class DatosEmpresaDenuncComponent implements OnInit {

  inputRazonSocial: string;
  flgRucDisabled = false;
  flgRazonSocialDisabled = true;
  cbk_empresa = 'RUC';
  inputRuc: string;
  empresa: Persona = new Persona();
  flgLectura = false;
  flgRegAutomatico = true;
  flgEmpreNoReg = false;
  flgAgregarRL = false;
  strFDscTitulo = 'Empresa o Agrupación';
  strFDscTitulo1 = 'Datos Empresa';
  strFDscTitulo2 = 'Razón Social';
  iconoEliminar = iconEliminar;
  flgMostrarEmpNoReg = true;
  DscMensajeSpinner = DscMensajeSpinner;
  listaEmpresaSunat: EmpresaSunat[] = [] ;
  boolFlgView = true;
  boolFlgNoSUNAT = false;
  // strDscReferencia:string = "";

  departamentos: Departamento[] = [];
  provincias: Provincia[] = [];
  distritos: Distrito[] = [];
  listaDenunXRL: DenuncianteXRepLegal[] = [];
  iconAgregar = iconAgregar;
  strDscPanel1 = 'Empresa o Agrupación';

  // listaPersonaXRepLeg:PersonaXRepLeg[] = [];

  dataSource: MatTableDataSource<DenuncianteXRepLegal>;
  dataSource2: MatTableDataSource<EmpresaSunat>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  @ViewChild(MatPaginator) paginator2: MatPaginator;
  @ViewChild(MatSort) sort2: MatSort;

  matTableColumnsDef = ['item', 'nombres', 'eliminar'];
  matTableColumnsDef2 = ['item', 'RUC', 'RazonSocial', 'seleccionar'];
  matTableColumnsEtiq = ['Ítem', 'RUC', 'Razón Social', 'Seleccionar'];
  matTableColumnsEtiqR = ['Ítem', 'Nombre Completo', 'Eliminar'];
  strMatTablePaginator = strMatTablePaginator;

  constructor(private externoService: ExternosService,
              public dialog: MatDialog,
              private maestraService: MaestrasService,
              private spinner: NgxSpinnerService,
              private personaService: PersonaService) {


              this._resetEmpresa();

              // this.dataSource = new MatTableDataSource();
            }

  ngOnInit() {

    this.maestraService.obtenerDepartamentos().subscribe(departamentos => {
      this.departamentos = departamentos;


    });

    if (this.boolFlgNoSUNAT) {

      this.boolFlgView = false;
      this.flgEmpreNoReg = true;

      this._cambioCheckEmpReg(true);

    }

  }

  setEtiquetasAgrupacion() {

    // console.log("AGrupación========");

    this.strFDscTitulo1 = 'Datos de Agrupación';
    this.strFDscTitulo2 = 'Nombre de Agrupación';

  }

  setMostrarEmprNoReg(flgValor: boolean) {

    this.flgMostrarEmpNoReg = flgValor;

  }

  _obtenerProvincias(codDep: string) {
    this.maestraService.obtenerProvincias(codDep).subscribe(data => {

        this.provincias = data;
    });
  }

  _obtenerDistritos(codDep: string , codProv: string) {

    this.maestraService.obtenerDistritos(codDep, codProv).subscribe(data => {
        // console.log(data);
          this.distritos = data;
      });
  }

  _eliminar(ev) {

    openModalMensajePrg(this.strFDscTitulo, strDscMsjPrgEliminar, this.dialog).subscribe(result => {

      // if(result != true)
      if (result == false) {

        this.listaDenunXRL.splice(this.listaDenunXRL.indexOf(ev), 1);
        this._cargarTableMaterial();

      }

    });

  }

  _abrirModalRL(numIndexEdit: number) {

    const configuracionGlobal = new MatDialogConfig();
    const vListOrig = cloneDeep(this.listaDenunXRL);
    let listPersonaXRepLeg: PersonaXRepLeg[] = null;
    let dcianteXRepLeg: DenuncianteXRepLegal = null;

    configuracionGlobal.disableClose = true;
    configuracionGlobal.autoFocus = true;

    configuracionGlobal.width = '60%';

    configuracionGlobal.data = {
      listModal : vListOrig,
      numIndexEdit
    };
    const  modal = this.dialog.open(ModalRepLegalComponent, configuracionGlobal);

    modal.afterClosed().subscribe(

         data => {

          // console.log("===========data");
          // console.log(data);

          if (data != null) {

            if (data.listModalRepLegal.length > 0) {


              listPersonaXRepLeg = data.listModalRepLegal;

              // console.log("=====ListPersonaXRepLeg",listPersonaXRepLeg);

              dcianteXRepLeg = new DenuncianteXRepLegal();

              dcianteXRepLeg.cdciantexrlNombres = listPersonaXRepLeg[listPersonaXRepLeg.length - 1].cpersonaxrlNombres;

              // console.log("=====dcianteXRepLeg",dcianteXRepLeg);

              this.listaDenunXRL.push(dcianteXRepLeg);

              // console.log("=====this.listaDenunXRL",this.listaDenunXRL);

              this._cargarTableMaterial();

            }

          }

         }
      );
  }

  _agregarRepLegal(event) {

    this._setFlgAgregarRL(event.checked);

  }

  _setFlgAgregarRL(flgValor: boolean) {

    this.flgAgregarRL = flgValor;

  }

  _resetEmpresa() {

    this.empresa = new Persona();

    if (this.flgEmpreNoReg) {

      this.empresa.cpersonaCdepartdomic = null;
      this.empresa.cpersonaCprovdomic = null;
      this.empresa.cpersonaCdistdomic = null;

    }


    this.listaDenunXRL = [];
    this.listaEmpresaSunat = [];

    this.inputRuc = '';
    this.inputRazonSocial = '';

    // this.cbk_empresa = null;


  }

  _cambioCheckEmpReg(boolFlgCheck: boolean) {

    this._setFlgEmpreNoReg(boolFlgCheck);
    this._resetEmpresa();

  }

  _cambiarEmpresaRegistada(evento) {

    // this._setFlgEmpreNoReg(evento.target.checked);
    // this._resetEmpresa();

    this._cambioCheckEmpReg(evento.target.checked);

  }

  _setFlgEmpreNoReg(flgValor: boolean) {

    this.flgEmpreNoReg = flgValor;

    this._setFlgRegAutomatico(!flgValor);

  }

  _setFlgRegAutomatico(flgValor: boolean) {

    this.flgRegAutomatico = flgValor;

  }

  _cargarTableMaterial() {


    setTimeout(() => {

      this.dataSource = new MatTableDataSource(this.listaDenunXRL);
      if (this.paginator != null) {this.paginator._intl.itemsPerPageLabel = DscTituloPaginator; }

      // console.log("===========this.paginator");
      // console.log(this.paginator);

      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

    }, 10);

  }

  _cargarTableMaterial2() {


    setTimeout(() => {

      this.dataSource2 = new MatTableDataSource(this.listaEmpresaSunat);
      if (this.paginator2 != null) {this.paginator2._intl.itemsPerPageLabel = DscTituloPaginator; }

      // console.log("===========this.paginator");
      // console.log(this.paginator);

      this.dataSource2.paginator = this.paginator2;
      this.dataSource2.sort = this.sort2;

    }, 10);

  }

  validarDatosEmpresa() {

    if (this.flgEmpreNoReg) {

      if (isEmpty(this.empresa.cpersonaRazonsocial)) {

        openModalMensaje(this.strFDscTitulo, 'Ingrese la razón social, por favor verifique', this.dialog);

        return false;

      }

    } else {

      if (isEmpty(this.empresa.cpersonaNrodoc)) {

        openModalMensaje(this.strFDscTitulo, 'Ingrese el RUC de la empresa, por favor verifique', this.dialog);

        return false;

      }

    }

    return true;

  }

  setModoLectura(flgValor: boolean) {

    this.flgLectura = flgValor;

  }


  _rucSeleccionado(evento) {

    this.inputRazonSocial = '';
    this.flgRucDisabled = false;
    this.flgRazonSocialDisabled = true;
    this._resetEmpresa();
    // console.log(this.cbk_empresa);
    // this.formEmpresaInvolucrada.get('input_razon_social').setValue('');
  }

  _razonSeleccionado() {
    this.inputRuc = '';
    this.flgRazonSocialDisabled = false;
    this.flgRucDisabled = true;
    this._resetEmpresa();
    // this.formEmpresaInvolucrada.get('input_ruc').setValue('');
  }

  _cargarUbigeo(vCodDepart: string, vCodProv: string, vCodDist: string, persona: Persona) {

    this.maestraService.obtenerProvincias(vCodDepart).subscribe(provincia => {

      this.provincias = provincia;

      persona.cpersonaCprovdomic = vCodProv;

      this.maestraService.obtenerDistritos(vCodDepart, vCodProv).subscribe(distrito => {

            this.distritos = distrito;

            persona.cpersonaCdistdomic = vCodDist;

        });
    });

    return persona;

  }

  _cargarDatosPersona(resultado, numCaso: number, idPersona: number) {

    let persona = new Persona();
    let vCodDepart = null;
    let vCodProv = null;
    let vCodDist = null;
    let vItem = null;
    let dscRepre = '';
    let vDenuncXRepLeg: DenuncianteXRepLegal = null;

    this.listaDenunXRL = [];

    switch (numCaso) {
      case 1:

        persona.cpersonaNrodoc = resultado.ruc;
        persona.cpersonaRazonsocial = resultado.razon_Social;
        persona.cpersonaDscdireccion = resultado.domicilio_Legal;
        persona.cpersonaDscreprelegal = resultado.representante;
        persona.npersonaId = idPersona;

        vCodDepart = resultado.ubigeo.substring(0, 2);
        vCodProv = resultado.ubigeo.substring(2, 4);
        vCodDist = resultado.ubigeo.substring(4, 6);

        persona.cpersonaCdepartdomic = vCodDepart;

        if (resultado.listaRepresentantes != null) {


            // HASTA QUE SE HABILITE REPRESENTANESTD SUNAT
          for (let index = 0; index < resultado.listaRepresentantes.length; index++) {

            vItem = null;
            dscRepre = resultado.listaRepresentantes[index];

            vItem = this.listaDenunXRL.find(x => x.cdciantexrlNombres == dscRepre);

            // console.log("==========vItem");
            // console.log(vItem);

            if (!vItem) {

              vDenuncXRepLeg = new DenuncianteXRepLegal();

              vDenuncXRepLeg.cdciantexrlNombres = dscRepre;

              this.listaDenunXRL.push(vDenuncXRepLeg);


            }

          }

        }



        break;

      case 2:

        persona = resultado;

        vCodDepart = persona.cpersonaCdepartdomic;
        vCodProv = persona.cpersonaCprovdomic;
        vCodDist = persona.cpersonaCdistdomic;

        persona.listaPersonaPorReplegal.forEach(element => {

          vItem = null;

          vItem = this.listaDenunXRL.find(x => x.cdciantexrlNombres == element.cpersonaxrlNombres);

          // console.log("=====vItem",vItem);

          if (!vItem) {

            vDenuncXRepLeg = new DenuncianteXRepLegal();

            vDenuncXRepLeg.cdciantexrlNombres = element.cpersonaxrlNombres;

            this.listaDenunXRL.push(vDenuncXRepLeg);

          }



        });

        // this.listaDenunXRL = persona.listaPersonaPorReplegal;

        break;

      default:
        break;
    }

    persona = this._cargarUbigeo(vCodDepart, vCodProv, vCodDist, persona);

    this.empresa = persona;

    this.empresa.cpersonaDscreferencia = ''; // SOLICITADO POR VERONICA

    this._cargarTableMaterial();

 }

 _checkSeleccionar(ruc: string, data: any) {

  this.listaEmpresaSunat.forEach(data1 => {

        if (data1.ruc == ruc) {

          data1.flgSeleccionar = data.target.checked;

          this.personaService.obtenerPersona(NumIdTipoDocRUC.toString(), data1.ruc).subscribe(personaMa => {

            const resultadoMa: Persona = JSON.parse(JSON.stringify(personaMa));

            // console.log("======resultadoMa",resultadoMa);

            this.externoService.obtenerRepresentanteLegal(data1.ruc).subscribe(representante => {

              representante.listaRetorno.forEach(element => {

                data1.listaRepresentantes.push(element.nombre);

              });

              if (resultadoMa) {

                if (resultadoMa.npersonaId == null || resultadoMa.npersonaId == 0) {

                  this._cargarDatosPersona(data1, 1, null);

                } else {

                  // this._cargarDatosPersona(resultadoMa,2,null);
                  this._cargarDatosPersona(data1, 1, resultadoMa.npersonaId);

                }

              } else {

                this._cargarDatosPersona(data1, 1, null);

              }

            });


          });

        } else {

          data1.flgSeleccionar = false;
        }
    });

}


  _obtenerEmpresa() {

    // this.flgDeshabilitaValidar = true;
    // this.dscTextoValidar =

    const isRuc = this.cbk_empresa; // this.formEmpresaInvolucrada.get('cbk_empresa').value;
    let valorInput = this.inputRazonSocial;
    let resultado; // :EmpresaSunat[] = [] ;
    let flgConsultaReniec = false;
    // let persona = new Persona();

    if (isRuc == 'RAZON_SOCIAL' ) {
      /// Refactorizar codigo
        if (valorInput != '') {

          this.spinner.show();


          this.externoService.buscarEmpresaXRazonSocial(valorInput).subscribe(data => {

            this.spinner.hide();

            data = (!data ? [] : data);

            this.listaEmpresaSunat  = JSON.parse(JSON.stringify(data));

            // console.log("======resultado SUNAT",this.listaEmpresaSunat);

            if (this.listaEmpresaSunat.length == 0) {

                openModalMensaje('No se encontró datos de la razón social', 'Debe ingresar una razón social valida', this.dialog);

            } else {

              this.listaEmpresaSunat.forEach(element => {

                element.flgSeleccionar = false;

              });

              this._cargarTableMaterial2();

            }



          }, err => {

            console.log(err);

            this.spinner.hide();

            openModalMensaje('No se encontró datos de la razón social', 'Debe ingresar una razón social valida', this.dialog);

          });


        } else {
          // this.flgDeshabilitaValidar = false;
          openModalMensaje('Empresa Involucrada', 'Debe ingresar una razón social', this.dialog);
        }

    } else {

      if (this.inputRuc != '') {
        // this.formEmpresaInvolucrada.get('input_ruc').value

        if (this.inputRuc.length < 11) { // this.formEmpresaInvolucrada.get('input_ruc').value.length
          // this.flgDeshabilitaValidar = false;
          openModalMensaje('Empresa Involucrada', 'Debe ingresar un ruc válido', this.dialog);

        } else {


          valorInput = this.inputRuc; // this.formEmpresaInvolucrada.get('input_ruc').value;

          this.personaService.obtenerPersonaRuc(NumIdTipoDocRUC.toString(), valorInput).subscribe(personaMa => {

            if(personaMa == null ){
              openModalMensaje('Empresa Involucrada', 'Debe ingresar un ruc válido', this.dialog);
              return ;
            }

            const resultadoMa: Persona = JSON.parse(JSON.stringify(personaMa));
            const vCodDepart = personaMa.cpersonaCdepartdomic;
            const vCodProv = personaMa.cpersonaCprovdomic;
            const vCodDist = personaMa.cpersonaCdistdomic;
            personaMa = this._cargarUbigeo(vCodDepart, vCodProv, vCodDist, personaMa);
            this.empresa = personaMa;
            let IdPersona = 0;
            let flgRLError = false;

            if (resultadoMa) {

              if (resultadoMa.listaPersonaPorReplegal) {

                if (resultadoMa.listaPersonaPorReplegal.length == 0) {

                  flgRLError = true;

                }

              } else {

                flgRLError = true;

              }

              if (flgRLError == true) {

                flgConsultaReniec = true;
                IdPersona = resultadoMa.npersonaId;

              }

            }

            this.spinner.hide();

          }, err => {

            this.spinner.hide();

            openModalMensaje('No se encontró datos del RUC', 'Servicio no disponible', this.dialog);

            console.log(err);

          });

        }

      } else {
        // this.flgDeshabilitaValidar = false;
        openModalMensaje('Empresa Involucrada', 'Debe ingresar un ruc', this.dialog);

      }

    }

  }

  getDatosEmpresa() {

    const vDenunciante: Denunciante =  new Denunciante();
    let vPersonaXRL: PersonaXRepLeg = null;

    //  console.log("============this.empresa");
    //  console.log(this.empresa);

    // if(!this.flgEmpreNoReg)
    // {

    vDenunciante.personaComplemento = this.empresa;
    vDenunciante.personaComplemento.npersonaIdtipdoc = NumIdTipDocPersJur;

    vDenunciante.personaComplemento.listaPersonaPorReplegal = [];

    this.listaDenunXRL.forEach(element => {

        vPersonaXRL = new PersonaXRepLeg();

        vPersonaXRL.cpersonaxrlNombres = element.cdciantexrlNombres;

        vDenunciante.personaComplemento.listaPersonaPorReplegal.push(vPersonaXRL);

      });

    // }

    vDenunciante.cdenuncianteFlgsinruc = ConvertirFlag(this.flgEmpreNoReg) ;

    vDenunciante.cdenuncianteDscagrup = this.empresa.cpersonaRazonsocial;
    vDenunciante.cdenuncianteCdepartcompl = this.empresa.cpersonaCdepartdomic;
    vDenunciante.cdenuncianteCprovcompl = this.empresa.cpersonaCprovdomic;
    vDenunciante.cdenuncianteCdistcompl = this.empresa.cpersonaCdistdomic;
    vDenunciante.cdenuncianteDscdirecccompl = this.empresa.cpersonaDscdireccion;
    vDenunciante.cdenuncianteDscrefdomccompl = this.empresa.cpersonaDscreferencia;

    vDenunciante.listaDenunciantePorReplegal = this.listaDenunXRL;

    return vDenunciante;

  }

  setDatosEmpresa(denunciante: Denunciante) {

    const vFlgSinRuc: string = denunciante.cdenuncianteFlgsinruc;

    // var vDenunciante:Denunciante =  new Denunciante();

    // console.log("==========denunciante");
    // console.log(denunciante);

    this._setFlgEmpreNoReg(getBooleanFlag(vFlgSinRuc));

    // this._setFlgEmpreNoReg(true);

    // console.log("==========this.flgEmpreNoReg");
    // console.log(this.flgEmpreNoReg);

    if (!this.flgEmpreNoReg) {

      this.empresa = denunciante.personaComplemento;

    }

    // console.log("==========111111111");
    // console.log("======this.empresa");
    // console.log(this.empresa);


    this.empresa.cpersonaRazonsocial = denunciante.cdenuncianteDscagrup;
    this.empresa.cpersonaCdepartdomic = denunciante.cdenuncianteCdepartcompl;
    this.empresa.cpersonaCprovdomic = denunciante.cdenuncianteCprovcompl;
    this.empresa.cpersonaCdistdomic = denunciante.cdenuncianteCdistcompl;
    this.empresa.cpersonaDscdireccion = denunciante.cdenuncianteDscdirecccompl;
    this.empresa.cpersonaDscreferencia = denunciante.cdenuncianteDscrefdomccompl;

    this.listaDenunXRL = denunciante.listaDenunciantePorReplegal;

    // console.log("==========2222222");

    this._cargarUbigeo(this.empresa.cpersonaCdepartdomic, this.empresa.cpersonaCprovdomic, this.empresa.cpersonaCdistdomic, this.empresa);

    // console.log("==========33333");

    this._cargarTableMaterial();

    // console.log("==========44444444");

  }

  _mayusculas(e, numCaso: number) {

      let vData = '';

      // console.log(e);
      // e.target.value = e.target.value.toUpperCase();

      vData = e.target.value; // .trim();

      e.target.value = vData;

      switch (numCaso) {
        case 1:

          this.empresa.cpersonaRazonsocial = vData;

          break;
        case 2:

          this.empresa.cpersonaDscdireccion = vData;

          break;

        case 3:

        this.empresa.cpersonaDscreferencia = vData;

        break;

        default:
          break;
      }


      // this.nombreMadre = this.nombreMadre.toUpperCase();
      // e.key = e.key.toUpperCase();
     }

    setCambioAtributos(numcaso: number) {

      switch (numcaso) {
        case 1:

          this.strDscPanel1 = 'Empresa';

          break;

        case 2:

          this.strDscPanel1 = 'Agrupación';

          break;

        default:
          break;
      }

    }

}
